import { ConnectableApp } from '@gdladder/shared/enums';

export function appToDisplayName(app: ConnectableApp) {
    switch (app) {
        case ConnectableApp.AREDL:
            return 'AREDL';
        case ConnectableApp.DISCORD:
            return 'Discord';
        case ConnectableApp.GITHUB:
            return 'GitHub';
    }
}
